import React from 'react';

import './Loader.styles.css';

const Loader = () => (
    <div className="lds-facebook">
        <div></div>
        <div></div>
        <div></div>
    </div>
);

export default Loader;
